module.exports = ".track-status-mcg {\n  float: left;\n  width: calc(100% / 4);\n  cursor: pointer;\n  background: #fff;\n  padding: 4px;\n  border: 1px solid #e2e1e1; }\n\n.track-status-mcg span {\n  width: 50%;\n  margin: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/maptracker/stop/khatta.component.scss
// module id = ./src/app/maptracker/stop/khatta.component.scss
// module chunks = main